module.exports = __webpack_public_path__ + "img/line.bed0dd6.png";